module.exports = __webpack_public_path__ + "static/media/cargo-partner.20ccf434.png";